var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{staticClass:"mt-0 pt-0 flex-grow-0",attrs:{"input-value":_vm.value,"label":"Ocultar eliminadas","hide-details":""},on:{"change":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }